<template>
  <div class="relationalDatabaseServiceResourceSearch">
    <Row :gutter="4" style="margin-bottom: 10px">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="5">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
    </Row>
    <Row :gutter="4">
      <Col span="4">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="4">
        <Input
          v-model="nameSearchKey"
          :placeholder="$t('RAM.common.QuerybyInstanceName')"
        />
      </Col>
      <Col span="4">
        <Input
          v-model="engineSearchKey"
          :placeholder="$t('RAM.common.SearchbyEngine')"
        />
      </Col>
      <Col span="4">
        <Input
          v-model="typeSearchKey"
          :placeholder="$t('RAM.common.QuerybyInstanceType')"
        />
      </Col>
      <Col span="4">
        <Select
          v-model="state"
          filterable
          :placeholder="$t('RAM.common.FilterbyOperatingStatus')"
          :transfer="true"
        >
          <Option value="" v-if="stateNameList.length > 0">{{
            $t("configuration_management.common.cloudType")
          }}</Option>
          <Option
            :value="item.id"
            v-for="item in stateNameList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:ali:relationalDatabaseServiceResourceAli:page'
          ]"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableRelationalDatabaseServiceResource from "../rds/TableRelationalDatabaseServiceResource";

var tableRelationalDatabaseServiceResource = TableRelationalDatabaseServiceResource;
export default {
  name: "RelationalDatabaseServiceResourceSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountNameSearchKey: "",
      companyIdList: [],
      accountName: "",
      nameSearchKey: "",
      engineSearchKey: "",
      typeSearchKey: "",
      state: "",
      stateNameList: [
        {
          id: 11,
          name: "creating"
        },
        {
          id: 12,
          name: "running"
        },
        {
          id: 13,
          name: "deleting"
        },
        {
          id: 14,
          name: "rebooting"
        },
        {
          id: 15,
          name: "DBInstanceClassChanging "
        },
        {
          id: 16,
          name: "transing"
        },
        {
          id: 17,
          name: "EngineVersionUpgrading"
        },
        {
          id: 18,
          name: "TransingToOthers"
        },
        {
          id: 19,
          name: "GuardDBInstanceCreating"
        },
        {
          id: 20,
          name: "Restoring"
        },
        {
          id: 21,
          name: "Importing"
        },
        {
          id: 22,
          name: "ImportingFromOthers"
        },
        {
          id: 23,
          name: "DBInstanceNetTypeChanging "
        },
        {
          id: 24,
          name: "GuardSwitching"
        },
        {
          id: 25,
          name: "INS_CLONING"
        }
      ]
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableElasticBlockStoreResource.methods.showAll();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("nameSearchKey", this.nameSearchKey);
      eventBus.$emit("engineSearchKey", this.engineSearchKey);
      eventBus.$emit("typeSearchKey", this.typeSearchKey);
      eventBus.$emit("state", this.state);
      tableRelationalDatabaseServiceResource.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
      });
    }
  }
};
</script>
<style scoped>
.relationalDatabaseServiceResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/rds/RelationalDatabaseServiceResourceSearch.vue